























































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Question from '../models/Question'
import { LETTER_FORMAT } from '../../client/utils/constants'
import { questionServiceParser } from '../../../helpers/question-parser'
import QuestionRadio from '../../client/components/atoms_molecules/QuestionRadio.vue'
import QuestionCheckBox from '../../client/components/atoms_molecules/QuestionCheckBox.vue'
import QuestionSelect from '../../client/components/atoms_molecules/QuestionSelect.vue'
import Simplemde from '../../client/components/atoms_molecules/Simplemde.vue'

import { resetStyleMathLive, checkMathLiveExist, createMathliveField, hideAllMathKeyboard } from '../../../lib/mathlive'
import { processAudioSpeak } from '../../../lib/speak_polly'
import Exam from "../../api/v2/models/exam";

@Component({
  components: {
    QuestionRadio,
    QuestionCheckBox,
    QuestionSelect,
    Simplemde
  }
})
export default class QuestionBodyComponent extends Vue {
  @Prop() question: Question
  @Prop({ default: false }) isAnswered: boolean
  @Prop({ default: 1 }) questionNumber: number
  @Prop({ default: 10 }) totalQuestionNumber: number
  @Prop({ default: 1 }) totalQuestion: number
  @Prop({}) exam: Exam
  LETTER_FORMAT = LETTER_FORMAT
  reRender: string = Date().toString()
  text: string = ''
  value: string[] = []
  time = 20
  score = 0
  totalScore = 0
  height = 200

  @Watch('question')
  watchQuestion() {
    this.text = ''
    this.value = []
    if (this.question.answerItems.length >= 3){
      this.height = 200 + this.question.answerItems.length * 20
    }
    else {
      this.height = 200
    }
    if (this.questionNumber == this.totalQuestion) {
      this.height = this.height + this.question.answerItems.length * 30
    }
  }

  get content(): string {
    if (!this.question) {
      return ''
    }
    setTimeout(() => {
      if (this.question.isTextfield) {
        (document.getElementsByClassName('textfield-question') as any).forEach((element: HTMLInputElement, index) => {
          element.value = this.value[index] || ''

          const answerItem = this.question.answerItems[index]
          if(checkMathLiveExist(answerItem.body)){
            createMathliveField(element)
          }
        })
      }

      // Text - Speak 実行
      processAudioSpeak(document, true)
    }, 100)
    return questionServiceParser(this.question.questionBody, this.question, true)
  }

  mounted() {
    resetStyleMathLive()
    if (this.questionNumber == this.totalQuestion) {
      this.height = this.height + this.question.answerItems.length * 30
    }
  }

  callBackChange(value) {
    this.value = value
  }

  callBackChangeOne(a) {
    this.value = [a]
  }

  @Watch('isAnswered')
  onAnswer() {
    if (!this.isAnswered) {
      return
    }

    if (this.question.isTextfield) {
      const textfieldQuestions = document.getElementsByClassName('textfield-question')
      this.value = []
      for (let index = 0; index < textfieldQuestions.length; index++) {
        this.value.push((textfieldQuestions[index] as HTMLInputElement).value)
      }
    }

    if (this.question.isInlineSelect) {
      const inlineSelectQuestions = document.getElementsByClassName('inline-select-question')
      this.value = []
      for (let index = 0; index < inlineSelectQuestions.length; index++) {
        this.value.push((inlineSelectQuestions[index] as HTMLInputElement).value)
      }
    }

    if (this.question.isTextarea && this.text) {
      this.value = [this.text]
    }

    this.totalScore = this.question.getTotalScore()
    if (!this.value || this.value.length === 0) {
      this.$emit('onAnswer', 0, this.totalScore)
      return
    }

    this.score = this.question.getScore(this.value)
    this.$emit('onAnswer', this.score, this.totalScore)
  }
}
